module.exports = __webpack_public_path__ + "assets/hotspots_primary.74b4b23b.svg";